/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext} from 'react';
import {Tag} from '..';
import {Rocket, Trophy} from '../../assets/icons/icons';
import {ARMcontext} from '../../utils/context/context';
import {LeadArticle, LeadHeader, LeadItem, LeadItemBase, LeadItemNumber, LeadItemWrap} from './styles';
import DefaultAvatar from '../../assets/icons/User.png';
import Teams from '../../utils/api/Teams';

export default ({title, icon = 'Rocket', data}: {title: string; icon?: string; data: Array<object | any>}) => {
  const {HandleSelectedPlayer, selectedPlayer} = useContext(ARMcontext);
  const TEAMS = new Teams();
  async function fetchSelectedPlayerInfo(player_id: string) {
    const playerInfo = await TEAMS.FetchSelectedPlayerInfo(player_id);

    if (playerInfo.success) {
      HandleSelectedPlayer(playerInfo.data);
    }
  }

  return (
    <LeadArticle>
      <LeadHeader>
        {icon === 'Rocket' ? <Rocket /> : <Trophy />}
        <span>{title}</span>
      </LeadHeader>
      <LeadItemWrap top={true}>
        {data.map((el, idx) => {
          if (idx < 3) {
            return (
              <LeadItem
                key={idx}
                onClick={e => fetchSelectedPlayerInfo(el?.player?._id)}
                ref={element => {
                  if (!element) return;

                  if (selectedPlayer._id === el?.player?._id) {
                    element.parentElement?.parentElement?.scrollTo({top: element.offsetTop - 750, behavior: 'smooth'});
                  }
                }}>
                {selectedPlayer._id ? (
                  selectedPlayer._id === el?.player?._id ? (
                    <LeadItemNumber color={'var(--PrimaryBlue)'}>
                      <span>{idx + 1}</span>
                    </LeadItemNumber>
                  ) : (
                    <LeadItemNumber color={idx === 0 ? 'rgba(133,140,160,1)' : ''}>
                      <span>{idx + 1}</span>
                    </LeadItemNumber>
                  )
                ) : (
                  <LeadItemNumber color={idx === 0 ? 'var(--PrimaryBlue)' : ''}>
                    <span>{idx + 1}</span>
                  </LeadItemNumber>
                )}

                <img src={el?.player?.picture || DefaultAvatar} alt="Armcare player" />
                <div>
                  <span>{el?.player?.fullName ? el?.player?.fullName : '-'}</span>
                  <Tag name={el?.player?.primaryPosition ? el?.player?.primaryPosition?.toUpperCase() : '-'} theme="Info" />
                </div>
                <div>
                  <div>
                    <span>Age</span>
                    <span>{el?.player?._age || '-'}</span>
                  </div>
                  <Tag name={(el?.percentile !== null ||el?.percentile !== undefined) ? `Percentile ${el?.percentile}%` : '-'} theme="Info" />
                </div>

                <LeadItemBase>
                  <span>{(el?.current !== null || el?.current !== undefined) ? `${el?.current} lbs` : '-'}</span>
                </LeadItemBase>
              </LeadItem>
            );
          } else {
            return <React.Fragment key={idx}></React.Fragment>;
          }
        })}
      </LeadItemWrap>
      {data.length > 3 && (
        <LeadItemWrap top={false}>
          {data.map((el, idx) => {
            if (idx >= 3) {
              return (
                <LeadItem
                  key={idx}
                  onClick={e => fetchSelectedPlayerInfo(el?.player?._id)}
                  ref={element => {
                    if (!element) return;

                    if (selectedPlayer._id === el?.player?._id) {
                      element.parentElement?.parentElement?.scrollTo({top: element.offsetTop - 750, behavior: 'smooth'});
                    }
                  }}>
                  {selectedPlayer ? (
                    selectedPlayer._id === el?.player?._id ? (
                      <LeadItemNumber color={'var(--PrimaryBlue)'}>
                        <span>{idx + 1}</span>
                      </LeadItemNumber>
                    ) : (
                      <LeadItemNumber color={''}>
                        <span>{idx + 1}</span>
                      </LeadItemNumber>
                    )
                  ) : (
                    <LeadItemNumber color={''}>
                      <span>{idx + 1}</span>
                    </LeadItemNumber>
                  )}
                  <img src={el?.player?.picture || DefaultAvatar} alt="Armcare player" />
                  <div>
                    <span>{el?.player?.fullName ? el?.player?.fullName : '-'}</span>
                    <Tag name={el?.player?.primaryPosition ? el?.player?.primaryPosition?.toUpperCase() : '-'} theme="Info" />
                  </div>
                  <div>
                    <div>
                      <span>Age</span>
                      <span>{el?.player?._age || '-'}</span>
                    </div>
                    <Tag name={(el?.percentile !== null ||el?.percentile !== undefined) ? `Percentile ${el?.percentile}%` : '-'} theme="Info" />
                  </div>

                  <LeadItemBase>
                    <span>{(el?.current !== null ||el?.current !== undefined) ? `${el?.current} lbs` : '-'}</span>
                  </LeadItemBase>
                </LeadItem>
              );
            } else {
              return <React.Fragment key={idx}></React.Fragment>;
            }
          })}
        </LeadItemWrap>
      )}
    </LeadArticle>
  );
};
